import { render, staticRenderFns } from "./SearchResults_EventList.vue?vue&type=template&id=866f1c3c&"
import script from "./SearchResults_EventList.vue?vue&type=script&lang=js&"
export * from "./SearchResults_EventList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports